import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";

const CONDITION_OPTIONS = ["Good", "Minor Damage", "Major Damage", "Non-Functional"];

const StockInConfirmModal = ({ show, onHide, item, onConfirm }) => {
  const [form, setForm] = useState({
    condition: "Good",
    qualityCheck: "Pass",
    remarks: "",
  });

  const handleChange = ({ target: { name, value } }) =>
    setForm((p) => ({ ...p, [name]: value }));

  const handleConfirm = () => {
    if (!form.remarks.trim()) {
      return; // show inline error or toast
    }
    onConfirm(form);
    setForm({ condition: "Good", qualityCheck: "Pass", remarks: "" });
  };

  if (!item) return null;

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-box-arrow-in-down me-2" />
          Stock In — {item.materialCode}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-3">
          Returned barcode: <strong>{item.returnedBarcode}</strong>
        </p>
        <Row>
          <Col md={12} className="commTopButtonRightLeftPadding mb-3">
            <label className="form-label fw-medium">Condition of returned item</label>
            <select
              name="condition"
              className="form-control inputBox"
              value={form.condition}
              onChange={handleChange}
            >
              {CONDITION_OPTIONS.map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          </Col>
          <Col md={12} className="commTopButtonRightLeftPadding mb-3">
            <label className="form-label fw-medium">Quality Check</label>
            <select
              name="qualityCheck"
              className="form-control inputBox"
              value={form.qualityCheck}
              onChange={handleChange}
            >
              <option value="Pass">Pass</option>
              <option value="Fail">Fail</option>
              <option value="Needs Repair">Needs Repair</option>
            </select>
          </Col>
          <Col md={12} className="commTopButtonRightLeftPadding mb-3">
            <TextAreaField
              className="inputBox"
              label="Store Remarks *"
              name="remarks"
              value={form.remarks}
              onChange={handleChange}
              rows={2}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary btn-sm" onClick={onHide}>
          Cancel
        </button>
        <button
          className="btnTable"
          onClick={handleConfirm}
          disabled={!form.remarks.trim()}
        >
          <i className="bi bi-check-circle me-1" />
          Confirm Stock In
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default StockInConfirmModal;